// Which package-guide actions a person can reach (Phase 1 shipping redesign, 2026-10-27).
//
// The card has two modes. "office" (the Sales Order page; the page is admin-gated) shows everything, as before.
// "operator" (the Shipping hub's package guide) shows the floor's work: seal, ship, stage, pickups, label and
// manifest reprints, Find, Prepare shipment, the part inspector, the standard finalize email. Everything that
// changes the plan itself is an office tool and shows only after "Office tools" (an Admin PIN, local to the card).
//
// A UI guard only: the API decides who may do what.

/** The floor's actions: shown in operator mode without the office unlock. */
export const OPERATOR_ACTIONS = Object.freeze([
  'sealBox', 'sealPallet',
  'ship', 'stage', 'confirmPickup', 'confirmPickupAll', 'shipAll', 'stageAll',
  'finalize',                 // the standard, unedited finalize email (editing it is 'finalizeEdit')
  'reprintLabels', 'reprintManifest', 'statusLabel', 'partLabels',
  'find', 'findAll',
  'prepareShipment',          // Prepare shipment: Pack into, Ship this pallet as it is, a new pallet for it
  'stagingAssign',            // the Staging queue's assign rows (+ their new pallet)
  'inspectPart', 'reload',
]);

/** The office tools: operator mode shows them only after the Admin PIN. Listed so the names are checked. */
export const OFFICE_ACTIONS = Object.freeze([
  'createPlan', 'commitPlan', 'deletePlan', 'refreshPlan', 'regeneratePlan', 'backfill',
  'printAllSlips', 'perJobSlips',
  'editPlan',                 // Edit plan and everything under it (zones, boxes, pallets, kit / purchased items)
  'editPositions',            // Re-layout boxes (auto) / Edit positions (manual)
  'reopenPlan', 'clearWip', 'unseal', 'moveMerge', 'convertContainer', 'rideAlongAssign',
  'planSettings',             // max pallet weight, max stack height, one email at SO completion
  'finalizeEdit',             // change the finalize email's recipients or text
]);

const OPERATOR = new Set(OPERATOR_ACTIONS);

export const GUIDE_MODES = Object.freeze(['office', 'operator']);

/** Can this action be shown? mode 'office' (or anything that is not 'operator'): every action. Operator mode: the
 *  floor's actions; any other action (an office tool, or a name nobody listed) only once the office unlocked it. */
export function guideAllows(mode, officeUnlocked, action) {
  if (mode !== 'operator') return true;
  if (OPERATOR.has(action)) return true;
  return officeUnlocked === true;
}
